import { SORT_TYPE } from 'shared/filter/sort/types';
import { HashMap } from 'shared/types/commonView';

export const FILTER_TYPE = {
  oneOfIds: 'oneOfIds',
  oneOfDirect: 'oneOfDirect',
  directId: 'directId',
  direct: 'direct',
  dateRange: 'dateRange',
  contains: 'contains',
  doesNotContain: 'doesNotContain',
  equals: 'equals',
  doesNotEqual: 'doesNotEqual',
  startsWith: 'startsWith',
  endsWith: 'endsWith',
  isEmpty: 'isEmpty',
  isNotEmpty: 'isNotEmpty',
  isAnyOf: 'isAnyOf',
  search: 'search',
  invalid: 'invalid',
} as const;

export const FILTER_LOGICAL_OPERATOR = {
  AND: 'and',
  OR: 'or',
} as const;

export type FilterLogicalOperator =
  (typeof FILTER_LOGICAL_OPERATOR)[keyof typeof FILTER_LOGICAL_OPERATOR];

export interface RelationsMap { hashMap: RelationsHashMap; matches: Matches }
type Matches = {
  name: string;
  matches: { path: string; type: string }[];
}[];

export interface SingleFilter {
  path: string;
  value:
    | { [key: string]: any; fromDate?: string; toDate?: string }[]
    | { fromDate: string; toDate: string }
    | string;
  type: string;
}

export type RelationsHashMap = HashMap<HashMap<string>>;

/**
 * Decides a condition before its filter runs: `true` passes the element,
 * `'exclude'` leaves it out, `false` runs the filter.
 */
export type FilterSkip<T> = (elem: T, filter: SingleFilter) => boolean | 'exclude';

export type Filter = <T>(data: {
  set: T[];
  filters: SingleFilter[];
  options?: {
    any?: boolean;
    skip?: FilterSkip<T>;
  };
}) => T[];

export type AsyncFilter = <T>(data: {
  set: T[];
  filters: SingleFilter[];
  relationsMap?: RelationsMap;
}) => Promise<T[]>;

export interface SortData {
  path: string;
  type: SORT_TYPE;
  order: 'asc' | 'desc';
  key: string;
}

export interface PaginationData {
  page: number;
  size: number;
}
